// Self-hosted server connections are not supported in StreamLain.
// This component is intentionally empty — it returns null unconditionally.
export const AddServer = () => {
  return null;
};
